import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from "./pages/Login"
import Signup from './pages/Signup';
import MapDetails from './pages/MapDetails';
import MapOfTheWeek from './pages/MapOfTheWeek';
import { useState, useEffect } from 'react';
import User from './pages/UserDetails';
import PointsLeaderboard from './pages/PointsLeaderboard';
import AdminCustomLeaderboardCreate from './pages/AdminCustomLeaderboardCreate';
import HardestMaps from "./pages/HardestMaps";
import AllMaps from './pages/AllMaps';
import ErrorMessageDisplay from "./components/ErrorMessageDisplay";
import { ErrorProvider } from './context/ErrorContext';
import useApi from './hooks/useApi';
import {Footer} from "./components/Footer";
import ScrollToTop from './components/ScrollToTop';

function AppContent() {
  const api = useApi();

  const [user, setUser] = useState({
    userName: '',
    discordID: '',
    token: '',
    isAdmin: false,
    mapPoints: [],
  })

  useEffect(() => {
    const initializeUser = async () => {
      const storedUser = localStorage.getItem('user');
      if (!storedUser) return;

      let parsedUser;
      try {
        parsedUser = JSON.parse(storedUser);
      } catch (error) {
        localStorage.removeItem('user');
        parsedUser = null;
      }

      if (!parsedUser) return;

      // Validate JWT token
      try {
        await api.user.validateToken(parsedUser.token);
      } catch (error) {
        // Token is expired or invalid, clear the user
        localStorage.removeItem('user');
        setUser({
          userName: '',
          discordID: '',
          token: '',
          isAdmin: false,
          mapPoints: [],
        });
        return;
      }

      setUser(parsedUser);

      try {
        await api.user.updatePoints(parsedUser.discordID);
      } catch (error) {
        // Errors are already shown by the API layer.
      }
    };

    initializeUser();
  }, [api]);

  return (
    <div className="App">
      <ErrorMessageDisplay/>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar user={user} setUser={setUser}/>
        <div className="pages">
          <Routes>
            <Route exact path='/' element={<Home/>} />
            <Route path='/maps' element={<AllMaps />} />
            <Route path='/map-of-the-week' element={<MapOfTheWeek user={user} />} />
            <Route path='/leaderboards/:mapKey' element={<MapDetails user={user} />} />
            <Route path='/:steamID' element={<MapDetails user={user} />} />
            <Route path='/user/:discordID' element={<User />}/>
            <Route path='/admin/custom-leaderboards/new' element={<AdminCustomLeaderboardCreate user={user} />} />
            <Route path='/login' element={<Login setUser={setUser}/>} />
            <Route path='/sign-up' element={<Signup setUser={setUser}/>} />
            <Route path='/points-leaderboard' element={<PointsLeaderboard />} />
            <Route path='/hardest-maps' element={<HardestMaps />} />
          </Routes>
        </div>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}

function App() {
  return (
    <ErrorProvider>
      <AppContent />
    </ErrorProvider>
  );
}

export default App;
